import {
  useConnectionState,
  useRemoteParticipants,
  useVoiceAssistant,
} from "@livekit/components-react";
import {
  ConnectionState,
  ParticipantKind,
  type RemoteParticipant,
} from "livekit-client";
import { getCompatibleAgentState } from "@/utils/get-compatible-agent-state";

export function isNowutalkAgentParticipant(participant: RemoteParticipant) {
  return (
    participant.kind === ParticipantKind.AGENT ||
    participant.identity.startsWith("agent-")
  );
}

/**
 * Supports both current LiveKit agents and the recovered NowUTalk agent, which
 * joins with ParticipantKind.AGENT but does not publish `lk.agent.state`.
 */
export function useCompatibleVoiceAssistant() {
  const voiceAssistant = useVoiceAssistant();
  const connectionState = useConnectionState();
  const remoteParticipants = useRemoteParticipants();
  const legacyAgent =
    remoteParticipants.find(isNowutalkAgentParticipant) ??
    remoteParticipants[0];
  const legacyRoomReady = connectionState === ConnectionState.Connected;

  return {
    ...voiceAssistant,
    agent: voiceAssistant.agent ?? legacyAgent,
    state: getCompatibleAgentState(
      voiceAssistant.state,
      Boolean(voiceAssistant.agent ?? legacyAgent) || legacyRoomReady,
    ),
  };
}
